import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchRTRWithdrawTransaction from '../../../../hooks/useApi/useFetchRTRWithdrawTransaction';
import VopayInstantWithdrawalInfo from './VopayInstantWithdrawalInfo';

type TransactionProps = {
  TransactionID: string;
  Notes: string;
};
type FC = FunctionComponent<TransactionProps>;

const VopayInstantWithdrawalContainer: FC = (props: TransactionProps) => {
  const { TransactionID, Notes } = props;
  const [RTRWithdrawTransaction, getRTRWithdrawTransaction] = useFetchRTRWithdrawTransaction({ bearer: '' });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.RTRWithdrawTransactionResponse>();

  useEffect(() => {
    getRTRWithdrawTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (RTRWithdrawTransaction) {
      setTransaction(RTRWithdrawTransaction);
    }
  }, [RTRWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <VopayInstantWithdrawalInfo transaction={transaction} Notes={Notes} />}</div>;
};

export default VopayInstantWithdrawalContainer;
